import type { PastEvent } from "../types";
import { pastEvents } from "../data";
import { Container } from "../components/ui/Container";
import { StarMark } from "../components/ui/StarMark";
import { assetUrl, siteUrl } from "../wordpress";
import "./Archive.css";

export function Archive() {
	return (
		<div className="archive-page">
			<Container>
				<header className="archive-page__header">
					<div>
						<p className="archive-page__kicker">Memòria Cosa Nova</p>
						<h1>Agenda</h1>
					</div>
					<div className="archive-page__intro">
						<StarMark className="archive-page__star" />
						<p>
							Trobades, presentacions i projectes que han fet créixer la nostra
							comunitat literària.
						</p>
					</div>
				</header>

				<ol className="archive-grid" aria-label="Esdeveniments passats">
					{pastEvents.map((event, index) => (
						<li
							className={[
								"archive-grid__item",
								index % 2 === 0
									? "archive-grid__item--left"
									: "archive-grid__item--right",
								event.featured ? "archive-grid__item--featured" : "",
							]
								.filter(Boolean)
								.join(" ")}
							key={event.id}
						>
							<ArchiveCard event={event} />
						</li>
					))}
				</ol>
			</Container>
		</div>
	);
}

function ArchiveCard({ event }: { event: PastEvent }) {
	const content = (
		<article className="archive-card">
			<div className="archive-card__media">
				<img src={assetUrl(event.image)} alt={event.imageAlt} loading="lazy" />
				<span className="archive-card__category">{event.category}</span>
			</div>
			<div className="archive-card__copy">
				<p className="archive-card__date">{event.date}</p>
				<h2>{event.title}</h2>
				<p className="archive-card__description">{event.description}</p>
				<p className="archive-card__venue">{event.venue}</p>
				{event.href && <span className="archive-card__link">Veure el projecte <span aria-hidden="true">↗</span></span>}
			</div>
		</article>
	);

	return event.href ? (
		<a className="archive-card__anchor" href={siteUrl(event.href)}>
			{content}
		</a>
	) : content;
}
